import { LocalDate } from '@js-joda/core';

import { ValidationRules } from '@dreryk/react-common';
import { DatePicker, dayValidator, DayValidatorResult } from '@dreryk/react-components';

import { isIssuedFromInThePast } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../translations';
import {
   DraftPrescriptionFieldName,
   DraftPrescriptionsFormBean,
   DraftPrescriptionsFormController,
} from '../../draftPrescriptions/DraftPrescriptionsForm.types';

const ISSUED_FROM_VALIDATION_RULES: ValidationRules<DraftPrescriptionsFormBean> = {
   required: true,
};

const ISSUED_FROM_DAY_VALIDATORS = [
   dayValidator.custom(
      (day: LocalDate): DayValidatorResult =>
         isIssuedFromInThePast(day) ? prescriptionTranslationKeys.issueDate.enterTodayOrFutureDate : undefined
   ),
];

type IssuedFromDatePickerProps = Pick<DraftPrescriptionsFormController, 'register'> & {
   readonly name: DraftPrescriptionFieldName;
   readonly defaultValue: LocalDate | null;
};

export const IssuedFromDatePicker = (props: IssuedFromDatePickerProps): JSX.Element => {
   return (
      <DatePicker
         controller={props.register(props.name, ISSUED_FROM_VALIDATION_RULES)}
         defaultValue={props.defaultValue}
         label={prescriptionTranslationKeys.issueDate.issuedFrom}
         compact
         dayValidators={ISSUED_FROM_DAY_VALIDATORS}
         withRequiredMark={false}
         testId={'issuedFrom'}
      />
   );
};
